import React from "react";
import { ModalComponent } from "../modal";
import { ModalTemplate } from "../modalTemplate";
import { isValidArray, months } from "../../../helper";
import {
  VIDEO_FORMATS,
  OTHER_FORMATS
  // OTHER_FORMATS_AGENDA
} from "../../../constant";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { successToastStyle, errorToastStyle } from "../../../customToast";

// font
import { faEdit, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export function UploadWithTitle({
  show = false, // default model visibility
  onClose = () => {}, // on close of modal function
  title = "Upload", // title of document modal
  titleField = false, // input field for title
  isLoading = false,
  onRemoveFile = () => {},
  onUpload = () => {},
  onTitleUpdate = () => {},
  onAttachFile = () => {},
  onEditToggle = () => {},
  containerClass = "",
  attachments = [],
  fileFormats = "image/*",
  loadingPercent = 0,
  isReview = false,
  isImageUpLoading,
  selectedMonth = new Date().getMonth + 1,
  newsLetter = false,
  onMonthChange = () => {},
  onYearChange = () => {},
  selectedYear = new Date().getFullYear(),
  uploadStatus,
  loadingNewsLetter
  // forFileSize
}) {
  const getDuration = (event, onAttachFile) => {
    let inputFile = { target: { files: event.target.files } };
    var passedEvent = event;

    var file = event.target.files[0],
      fileFormat = file.type,
      reader = new FileReader();

    var extension = file.name
      .substr(file.name.lastIndexOf(".") + 1, file.name.length)
      .toLowerCase();

    let isVideo = VIDEO_FORMATS.includes(extension);
    let formatsSupportedOtherThanVideo = OTHER_FORMATS.includes(extension);
    // let formatsSupportedOtherThanVideo = forFileSize
    //   ? OTHER_FORMATS_AGENDA.includes(extension)
    //   : OTHER_FORMATS.includes(extension);
    !isVideo && formatsSupportedOtherThanVideo
      ? onAttachFile(passedEvent)
      : (reader.onload = function(event) {
          var blob = new Blob([event.target.result], { type: fileFormat }),
            url = URL.createObjectURL(blob),
            video = document.createElement("video");

          video.preload = "metadata";
          video.addEventListener("loadedmetadata", function(event) {
            video.duration > 60.999 &&
              toast.error(
                <p className="toast-text-alignment">
                  The file exceeds the maximum size limit of 250 MB or duration
                  limit of 60s
                </p>,
                errorToastStyle
              );
            video.duration <= 60.999 && onAttachFile(inputFile);
            URL.revokeObjectURL(url);
          });

          video.src = url;
        });
    reader.readAsArrayBuffer(file);
  };

  const currentYear = new Date().getFullYear();

  const years = Array.from({ length: currentYear - 2000 + 1 }, (_, index) => {
    const year = currentYear - index;
    return { label: year.toString(), value: year };
  });

  const today = new Date();
  const currentMonth = today.getMonth() + 1;

  return (
    <ModalComponent
      loadingPercent={loadingPercent}
      show={show}
      centered="centered"
      onClose={onClose}
      backdrop="static"
      containerClass={`upload-attachment-with-files ${containerClass} download-upload-popup`}
      isLoading={isLoading}
      loadingNewsLetter={loadingNewsLetter}
      newsLetter={newsLetter}
      uploadStatus={uploadStatus}
      template={
        <ModalTemplate
          loadingPercent={loadingPercent}
          headerTitle={newsLetter ? "Upload Newsletter" : "Upload File"}
          onClose={onClose}
          onSubmit={onUpload}
          onSubmitTitle="Upload"
          submitDisable={!(isValidArray(attachments) && attachments.length)}
          isImageUpLoading={isImageUpLoading}
          uploadStatus={uploadStatus}
          isReview={isReview}
          newsLetter={newsLetter}
          loadingNewsLetter={loadingNewsLetter}
          bodyTemplate={
            <section className="attachment-section">
              <section className="attachment-section-file-upload">
                <label
                  for="attachments"
                  className={loadingPercent > 0 ? "btn disabled" : "btn"}
                >
                  Browse
                  <input
                    id="attachments"
                    type="file"
                    title=""
                    disabled={loadingNewsLetter}
                    onChange={e => {
                      const input = e.target;
                      getDuration(e, onAttachFile);
                      if (isReview) {
                        setTimeout(() => {
                          input.value = "";
                        }, 0);
                      }
                    }}
                    accept={fileFormats}
                  />
                </label>
              </section>
              <section className="attachment-section-title">{title}</section>
              {isValidArray(attachments) ? (
                <section className="attachment-with-title">
                  {isValidArray(attachments)
                    ? attachments.map((value, index) => (
                        <div className="attachments-files-section">
                          <section
                            className={`attachments-files-section-header ${
                              loadingPercent > 0 ? "disabled" : ""
                            }`}
                          >
                            <span
                              style={{
                                width: !isReview ? "85%" : "100%",
                                wordWrap: "break-word"
                              }}
                            >
                              {value.name}
                            </span>
                            <span
                              style={{ width: !isReview ? "15%" : "inherit" }}
                            >
                              {(titleField && !isReview && (
                                <FontAwesomeIcon
                                  icon={faEdit}
                                  onClick={() => onEditToggle(index)}
                                />
                              )) ||
                                null}
                              {(onRemoveFile && (
                                <FontAwesomeIcon
                                  icon={faTrashAlt}
                                  onClick={() => onRemoveFile(index)}
                                />
                              )) ||
                                null}
                            </span>
                          </section>
                          {titleField && value.toggleEdit && !isReview ? (
                            <Form.Control
                              className={
                                loadingPercent > 0 || loadingNewsLetter
                                  ? "disabled"
                                  : ""
                              }
                              type="text"
                              placeholder={
                                newsLetter ? "Enter Title" : "File Name"
                              }
                              value={value.title}
                              onChange={onTitleUpdate}
                            />
                          ) : null}
                        </div>
                      ))
                    : null}
                </section>
              ) : null}
              {newsLetter && (
                <div className="dropdown-month-year-newsletter">
                  <div className="input-field-left select-field select-month">
                    <section className="month-year-label-newsletter">
                      Month<span className="mandatory">*</span>
                    </section>
                    <select
                      class="form-select"
                      aria-label="Default select example"
                      className={`select-dropdown-attach ${
                        selectedMonth == "" ? "placeholder" : "selected"
                      }`}
                      style={{ padding: "10px", borderColor: "#ced4da" }}
                      value={selectedMonth}
                      disabled={loadingNewsLetter}
                      onChange={e => {
                        onMonthChange(e.target.value);
                      }}
                    >
                      <option value="" style={{ color: "#ababab" }}>
                        Select Month
                      </option>
                      {months &&
                        months.map(month => {
                          return (
                            <option
                              className="select-month-upload"
                              value={month.value}
                              disabled={
                                selectedYear == currentYear &&
                                month.value > currentMonth
                              }
                            >
                              {month.label}&nbsp;&nbsp;&nbsp;
                            </option>
                          );
                        })}
                    </select>
                  </div>
                  <div className="input-field-left select-field">
                    <section className="month-year-label-newsletter">
                      Year<span className="mandatory">*</span>
                    </section>

                    <select
                      class="form-select"
                      aria-label="Default select example"
                      className={`select-dropdown-attach ${
                        !selectedYear ? "placeholder" : "selected"
                      }`}
                      value={selectedYear}
                      disabled={loadingNewsLetter}
                      onChange={e => {
                        onYearChange(e.target.value);
                      }}
                      style={{ padding: "10px", borderColor: "#ced4da" }}
                    >
                      <option value="" style={{ color: "#ababab" }}>
                        Select Year
                      </option>
                      {years &&
                        years.map(state => {
                          return (
                            <option
                              value={state.value}
                              className="select-month-upload"
                            >
                              {state.label}
                            </option>
                          );
                        })}
                    </select>
                  </div>
                </div>
              )}
            </section>
          }
        />
      }
    />
  );
}
